import { UMFormGroup } from '../../urbanmap/_components';
import { contractLabel, contractMonths } from './domain';
import { PC, UMR, caption } from './tokens';
import type { ContractPeriod } from './types';

interface Props {
  value: ContractPeriod;
  onChange: (c: ContractPeriod) => void;
}

const FIELD: React.CSSProperties = {
  width: '100%',
  height: 32,
  boxSizing: 'border-box',
  border: `1px solid ${UMR.borderInput}`,
  borderRadius: 0,
  padding: '1px 8px',
  fontSize: 12,
  fontFamily: 'system-ui',
  color: UMR.black,
  background: UMR.white,
  outline: 'none',
};

/** Un sélecteur de mois (AAAA-MM) par borne du contrat. */
function MonthField({ label, value, min, onChange }: { label: string; value: string; min?: string; onChange: (v: string) => void }) {
  return (
    <UMFormGroup label={label}>
      <input
        className="um-input"
        type="month"
        value={value}
        min={min}
        aria-label={label}
        onChange={(e) => onChange(e.target.value)}
        style={FIELD}
      />
    </UMFormGroup>
  );
}

/** Période du contrat : mois de début et mois de fin, bornes incluses. */
export function ContractFields({ value, onChange }: Props) {
  const months = contractMonths(value);
  const invalid = months === 0;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div style={{ display: 'flex', gap: 8 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <MonthField label="Début du contrat" value={value.start} onChange={(start) => onChange({ ...value, start })} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <MonthField label="Fin du contrat" value={value.end} min={value.start} onChange={(end) => onChange({ ...value, end })} />
        </div>
      </div>
      <div style={{ ...caption, color: invalid ? PC.dangerText : UMR.textSecondary }}>
        {invalid ? 'La fin du contrat doit être postérieure ou égale au début.' : contractLabel(value)}
      </div>
    </div>
  );
}
